import { ResourceKey } from "@/constants/resources";

export type ActionJobStatus =
  | "pending"
  | "running"
  | "completed"
  | "completed_with_errors"
  | "failed";

export interface ActionJob {
  id: string;
  type: "bulk_delete";
  resource: ResourceKey;
  status: ActionJobStatus;
  total: number;
  succeeded: number;
  failed: number;
  error: string | null;
  createdAt: string;
  startedAt: string | null;
  finishedAt: string | null;
  seenAt: string | null;
  //* Présent seulement tant que le job est actif
  targetIds?: string[];
}

export interface ActionJobFailure {
  targetId: string | null;
  label: string | null;
  error: string | null;
}

export interface ActionJobDetails extends ActionJob {
  failures: ActionJobFailure[];
}

export interface ActionJobForm {
  type: "bulk_delete";
  resource: ResourceKey;
  ids: string[];
}

export const isActiveActionJob = (job: Pick<ActionJob, "status">) =>
  job.status === "pending" || job.status === "running";
